import {
  FileStack,
  FileUp,
  PenLine,
  ScanLine,
  Sparkles,
  ChevronRight,
  ArrowRight,
} from "lucide-react";

export type ContractHubAction =
  | "ai"
  | "simple"
  | "template"
  | "upload"
  | "scan";

type Props = {
  onBack: () => void;
  onSelect: (action: ContractHubAction) => void;
};

const OPTIONS: Array<{
  id: ContractHubAction;
  title: string;
  blurb: string;
  Icon: typeof Sparkles;
  soon?: boolean;
}> = [
  {
    id: "ai",
    title: "ایجاد سند از طریق هوش مصنوعی",
    blurb: "شرح کوتاه بنویسید یا فایل بدهید؛ عوامل پلتفرم قرارداد را می‌سازند.",
    Icon: Sparkles,
  },
  {
    id: "simple",
    title: "محیط نگارش ساده",
    blurb: "همان صفحهٔ باز کردن Word با یک سند خالی؛ بنویسید، قالب‌بندی کنید و در حساب ذخیره کنید.",
    Icon: PenLine,
  },
  {
    id: "template",
    title: "براساس نمونه آماده",
    blurb: "قالب‌های آماده قراردادی.",
    Icon: FileStack,
    soon: true,
  },
  {
    id: "upload",
    title: "بارگذاری سند",
    blurb: "آپلود PDF یا Word، یا اسکن با دوربین دستگاه.",
    Icon: FileUp,
  },
];

export function ContractDraftHub({ onBack, onSelect }: Props) {
  return (
    <div className="flow-page consumer-shell">
      <header className="flow-page-head">
        <button type="button" className="text-back" onClick={onBack}>
          <ArrowRight size={16} />
          بازگشت
        </button>
        <span className="consumer-kicker">شروع قرارداد</span>
        <h1>بهترین مسیر ساخت سند را انتخاب کنید</h1>
        <p>
          بسته به این‌که ایده خام دارید، فایل آماده دارید یا می‌خواهید با دوربین
          شروع کنید.
        </p>
        <div className="hero-art">
          <img src="/illustrations/dashboard-contract.svg" alt="" />
        </div>
      </header>
      <div className="flow-option-grid">
        {OPTIONS.map((opt) => (
          <button
            key={opt.id}
            type="button"
            className={`flow-option-card${opt.soon ? " soon" : ""}`}
            disabled={opt.soon}
            onClick={() => {
              if (opt.soon) return;
              if (opt.id === "upload") {
                onSelect("upload");
                return;
              }
              onSelect(opt.id);
            }}
          >
            <opt.Icon size={22} className="flow-option-icon" aria-hidden />
            <div className="flow-option-copy">
              <strong>
                {opt.title}
                {opt.soon ? " · به‌زودی" : ""}
              </strong>
              <span>{opt.blurb}</span>
            </div>
            {!opt.soon ? <ChevronRight size={18} className="flow-option-chevron" /> : null}
          </button>
        ))}
        <button
          type="button"
          className="flow-option-card accent-soft"
          onClick={() => onSelect("scan")}
        >
          <ScanLine size={22} className="flow-option-icon" aria-hidden />
          <div className="flow-option-copy">
            <strong>اسکن با دوربین</strong>
            <span>عکس بگیرید، گوشه‌ها را تنظیم کنید و PDF چندصفحه‌ای بسازید.</span>
          </div>
          <ChevronRight size={18} className="flow-option-chevron" />
        </button>
      </div>
    </div>
  );
}
